/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {SuccessCover, SuccessLayout, SuccessQuote, SuccessRate, SuccessSupport, BlogSocials, Meta} from "@/comps/index";
import {assetUrl} from "@/utils/cdn";
import {getServerSideProps as SSG} from "@/ssr/common";
export const getServerSideProps = SSG;
const MDXLayout = SuccessLayout;
function _createMdxContent(props) {
  return _jsxs(_Fragment, {
    children: [_jsx(Meta, {
      title: "Creator success story - @evgeniya_smolina",
      description: "Learn from inspiring success stories of Zoomerang creators on creating and selling video templates on Template Marketplace. See how video creators achieved real results with monetization.",
      tags: "#successfulstory, #videocreator, #videotemplate",
      cover: assetUrl("/covers/success-story.jpg")
    }), "\n", _jsx(SuccessCover, {
      username: "evgeniya_smolina",
      nickname: "Evgeniya Smolina",
      short: "Evgeniya",
      source: "evgeniya",
      title: "Creating content for social networks for free is good, but monetizing it through Zoomerang is even better.",
      paragraphs: ["I initially aimed to grow my TikTok audience and had no prior interest in video editing, so I started by filming videos on various topics. However, after discovering an intriguing effect in a video, I was inspired to explore editing and began my journey as a video editor.", "As a self-taught editor, I created tutorials for others that helped me improve my skills and increase my social engagement. Soon the Zoomerang team noticed me and offered to collaborate."]
    }), "\n", _jsx(SuccessRate, {
      used: "1.5M",
      followers: "38K",
      revenue: "$3,000+",
      title: "Increase Visibility & Income",
      advice: "As a creator, using Zoomerang my main goal is to showcase my short-form content by diversifying it in the app with my own ideas as well as monetizing my creativity."
    }), "\n", _jsx(SuccessSupport, {
      used: "1.5M",
      followers: "38K",
      revenue: "$3,000+",
      support: "At the initial stage, Zoomerang support helped me quickly understand the application and master the necessary functions.They share creative ideas for creating templates and always do proper testing to make sure the templates work correctly. I always received help whenever I had questions or technical problems. They even found an option to transfer funds in case of problems that arose at that time.",
      success: "Since I started using Zoomerang as a creator, I have increased my presence on several social networks."
    }), "\n", _jsx(SuccessQuote, {
      name: "Evgeniya Smolina",
      role: "Template Creator at Zoomerang",
      quote: "I joined Zoomerang with the aim to sell my short-form videos. I am grateful to this company for creating this opportunity for creative people. If you’re good at video editing, Zoomerang Template Marketplace is a must-try platform!",
      source: "evgeniya"
    }), "\n", _jsx(BlogSocials, {})]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
